import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {ActivatedRoute} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {takeUntil} from "rxjs/operators";
import {MatTabChangeEvent} from "@angular/material/tabs";
import {HttpErrorResponse} from "@angular/common/http";
import {WarehouseProduct} from "../../../shared/interface/warehouse-product";
import {WarehouseService} from "../../../shared/services/warehouse.service";

@Component({
  selector: 'app-warehouse-product-details',
  templateUrl: './warehouse-product-details.component.html',
  styleUrls: ['./warehouse-product-details.component.scss']
})
export class WarehouseProductDetailsComponent implements OnInit, OnDestroy {

  uuid?: string = null;
  warehouseProductObject?: WarehouseProduct;
  warehouseProduct: ReplaySubject<WarehouseProduct> = new ReplaySubject<WarehouseProduct>(1);
  modify = false;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private route: ActivatedRoute,
    private warehouseService: WarehouseService,
    private snack: MatSnackBar,
  ) { }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.uuid = params.id;
        this.loadWarehouseProduct();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  onTabChange(e: MatTabChangeEvent): void {
  }

  loadWarehouseProduct(): void {
    this.warehouseService.getProduct(this.uuid).subscribe((warehouseProduct: WarehouseProduct) => {
      this.warehouseProduct.next(warehouseProduct);
      this.warehouseProductObject = warehouseProduct;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych produktu', error.status.toString(), {
        duration: 2000
      });
    });
  }

}
